(function() {
  ['input','focus','keypress'].forEach( evt => 
   
    document.addEventListener(evt, ValidateEmail)
);
  function ValidateEmail(e)
{
  var a= document.querySelector('[data-newsletter]').value;
   if (e.which == 32){document.querySelector('[data-newsletter]').value='';}
var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
if(a.match(mailformat))
{
document.querySelector(".newsletter-error").style.display="none";
   $(".footer-email-submit").attr("disabled", false);
}
else
{
document.querySelector(".newsletter-error").style.display="block";
document.querySelector(".newsletter-error").innerHTML="Invalid Email";
  $(".footer-email-submit").attr("disabled", true);
}
}
 })();

    $("body").delegate('.spr-starrating','click',function(){
      alert();
        location.href = "#shopify-product-reviews";
    });








